<template>
  <div class="featured-dorms__list dorm-card__list user-settings">
    <container>
<Modal2 :active="showSuccessMessage" @onModalClose="closeModal">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title" >YOUR SETTINGS UPDATED!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Accounts settings updated.</span></p>
      <p ><span class= "mycolorBlue">Please check you updated account information.</span></p>
    </div>
     </div>
</div>
</Modal2>           
      <div class="user-settings__top">
        <div class="user-settings__profil">
          <div class="left-one">
            <div class="left">
              <!-- <img src="@/assets/img/comment-photo.png" class="user-settings__profil-img" alt=""> -->
              <avatar :fullname="first_name + ' ' + last_name" size="96" color="#4b5ba4"></avatar>
            </div>
            <div class="right">
              <p class="user-settings__profil-name">Welcome {{ first_name }} {{ last_name }}!</p>
              <p class="user-settings__profil-mail">
                {{ mail1 }}
              </p>
            </div>
          </div>
          <div class="right-block mypointer" v-on:click="logout()">
            <p class="user-settings__profil-name">
            <p class="exit-text" >Logout</p>
            <p>
              <span class="sign-out" >
                <svg-icon type="icon-sign-out"/>
              </span>
            </p>
          </div>
        </div>

      </div>
    </container>
    <container>
      <div class="login-box login-box--personal">
        <div class="login-box__group">
          <h3 class="login-box__title setting">USER SETTINGS</h3>
          <v-input placeholder="Firstname" v-model="form.first_name"/>
          <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label>
          <v-input placeholder="Lastname" v-model="form.last_name"/>
          <label for="password" v-if="emptyLastName" class="myValidationText">Can not be leave empty!</label>  
          <v-input placeholder="Telephone" v-model="form.phone"/>
          <label for="password" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
          <v-input placeholder="E-mail" v-model="form.email"/>
          <label for="password" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label>
          <p>&nbsp;</p>
          <h3 class="login-box__title setting color-blue">EDUCATION INFORMATION</h3>
            <VueSelectTempUniversity :options="universities" placeholder="Select Genre"  @onselect="selectUniversity"/>
            <VueSelectTempFaculty v-if="facultyEnabled" placeholder="Select Studio" :options="faculties"  @onselect="selectFaculty"/>
          <SelectBox2 v-else myplaceholder="Select Studio" :options="districts" :title="district_name" @onselect="selectDistrict" disabled/>
<!--           <div class="select-title" @click="showDate">Doğum Tarihiniz</div>
          <div class="select-gen">
            <div class="section__right" style="border-bottom: 1px solid #e5eaf0;" v-show="show">
              <select-box :options="days" title="Select Day"/>
              <select-box :options="month" title="Select Month"/>
              <select-box :options="year" title="Select Year"/>
            </div>
          </div> -->
        </div>
          <button v-if="sendEnabled" class="button green fw shadow-none login-box__submit"
                  @click="sendForm()">
        <span class="button__wrp">
          <span class="button__txt">SAVE</span>
        </span>
          </button>
          <button v-if="!sendEnabled" class="button green fw shadow-none login-box__submit">
        <span class="button__wrp">
          <span class="button__txt">SAVING</span>
        </span>
          </button>          
      </div>

      <div class="login-box session">
        <h3 class="login-box__title">SESSION SETTINGS</h3>
        <v-input placeholder="Current Password" v-model="password1" />
        <label for="password" v-if="emptyPassword1"  class="myValidationText">Can not be leave empty!</label>
        <label for="password" v-if="wrongPassword1"  class="myValidationText">Wrong password!</label>
        <v-input placeholder="New Password" v-model="password2"/>
        <label for="password" v-if="emptyPassword2" class="myValidationText">Can not be leave empty!</label>
        <label for="phone" v-if="shortPassword" class="myValidationText">Password must be at least 6 characters!</label>
        <v-input placeholder="New Password Again" v-model="password3"/>
        <label for="password" v-if="emptyPassword3" class="myValidationText">Can not be leave empty!</label>
        <label for="phone" v-if="shortPasswordCheck" class="myValidationText">Password must be at least 6 characters!</label>
        <label for="password" v-if="notSamePassword" class="myValidationText">Both passwords must be same!</label>        
        <!--<v-select placeholder="Placeholder" :options="city"/>-->
        <button class="button green fw shadow-none login-box__submit" style="    margin-top: 25px;"
        @click="sendSessionSettings()">
          <span class="button__wrp">
            <span class="button__txt">SAVE</span>
          </span>
        </button>
      </div>
    </container>
   
  </div>
</template>

<script>
import SelectBox from '@/components/SelectBox'
import Avatar from 'vue-avatar-component'
import { mapGetters } from 'vuex'
import { SET_USER_INFO, UNSET_TOKEN } from '@/store/mutations.type'
import axios from 'axios'
import VueSelectTempUniversity from '@/components/VueSelectTempUniversity1'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty1'
import VueSelect2 from '@/components/VueSelect2'
import SelectBox2 from '@/components/SelectBox2'
import Modal2 from '@/components/Modal2'
export default {
  name: 'UserSettings',
  components: {
    SelectBox, Avatar, VueSelectTempUniversity, VueSelectTempFaculty, VueSelect2, SelectBox2, Modal2
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Account Settings',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/kullanici-yonetimi/' }
      ] 
    }
  },  
  data () {
    return {
      errors: [],
      sendEnabled: true,
      showSuccessMessage: false,
      emptyName: false,
      emptyLastName: false,
      emptyPhone: false,
      emptyEmail: false,
      notSamePassword: false,      
      password1: '',
      password2: '',
      password3: '',
      wrongPassword1: false,
      emptyPassword1: false,
      emptyPassword2: false,
      emptyPassword3: false,
      shortPasswordCheck: false,
      shortPassword: false,
      username: '',
      facultyEnabled: false,
      form: {
      first_name: '',
      last_name: '',
      university_id: null,
      university_name: 'Select Genre',
      faculty_id: null,
      faculty_name: 'Select Studio',
      phone1: '',
      email1: '',
      },
      show: false,
      universities: [],
      faculties: [],      
      links: [
        {
          id: 0,
          title: 'Account Settings',
          to: '/kullanici-ayarlar'
        },
        {
          id: 1,
          title: 'Reservations',
          to: '#'
        }
/*         {
          id: 2,
          title: 'Teklifler',
          to: '/kullanici-teklifler'
        } */, 
        {
          id: 3,
          title: 'Lists',
          to: '/kullanici-yorumlar'
        },
        {
          id: 4,
          title: 'Favorites',
          to: '/user-favorites'
        },
       {
          id: 5,
          title: 'Watchlist',
          to: '/user-watchlist'
        },       
        {
          id: 6,
          title: 'Rated Movies',
          to: '/user-ratedmovies'
        }        
      ],
      days: [
        {
          name: '01',
          value: '01',
          selected: false
        },
        {
          name: '02',
          value: '02',
          selected: false
        },
        {
          name: '03',
          value: '03',
          selected: false
        },
        {
          name: '04',
          value: '04',
          selected: false
        },
        {
          name: '05',
          value: '05',
          selected: false
        },
        {
          name: '06',
          value: '06',
          selected: false
        },
        {
          name: '08',
          value: '08',
          selected: false
        },
        {
          name: '09',
          value: '09',
          selected: false
        },
        {
          name: '10',
          value: '10',
          selected: false
        },           
        {
          name: '11',
          value: '11',
          selected: false
        },
        {
          name: '12',
          value: '12',
          selected: false
        },
        {
          name: '13',
          value: '13',
          selected: false
        },
        {
          name: '14',
          value: '14',
          selected: false
        },
        {
          name: '15',
          value: '15',
          selected: false
        },
        {
          name: '16',
          value: '16',
          selected: false
        },
        {
          name: '17',
          value: '08',
          selected: false
        },
        {
          name: '18',
          value: '18',
          selected: false
        }             
      ],
      month: [
        {
          name: 'Ocak',
          value: 'Ocak',
          selected: false
        },
        {
          name: 'Şubat',
          value: 'Şubat',
          selected: false
        },
        {
          name: 'Mart',
          value: 'Mart',
          selected: false
        },
        {
          name: 'Nisan',
          value: 'Nisan',
          selected: false
        },
        {
          name: 'Mayıs',
          value: 'Mayıs',
          selected: false
        },
        {
          name: 'Haziran',
          value: 'Haziran',
          selected: false
        },
        {
          name: 'Temmuz',
          value: 'Temmuz',
          selected: false
        }
      ],
      year: [
        {
          name: '1994',
          value: '1994',
          selected: false
        },
        {
          name: '1995',
          value: '1995',
          selected: false
        },
        {
          name: '1996',
          value: '1996',
          selected: false
        },
        {
          name: '1997',
          value: '1997',
          selected: false
        },
        {
          name: '1998',
          value: '1998',
          selected: false
        },
        {
          name: '1999',
          value: '1999',
          selected: false
        },
        {
          name: '2000',
          value: '2000',
          selected: false
        }
      ],
    }
  },
  methods: {
    closeModal() {
      this.showSuccessMessage = false
    },    
    sendSessionSettings () {
      this.wrongPassword1 = false
      this.emptyPassword1 = false
      this.emptyPassword2 = false
      this.emptyPassword3 = false
      this.shortPassword = false
      this.shortPasswordCheck = false
      this.notSamePassword = false

      if (!this.password1) {
        this.emptyPassword1 = true
      }      
      if (!this.password2) {
        this.emptyPassword2 = true
      }
      if (!this.password3) {
        this.emptyPassword3 = true
      }
      if(!this.emptyPassword2 && this.password2.length < 6) {
        this.shortPassword = true
      }
      if(!this.emptyPassword3 && this.password3.length  < 6) {
        this.shortPasswordCheck = true
      }
      if (!this.emptyPassword3 && !this.shortPassword && !this.shortPasswordCheck && this.password2 != this.password3) {
        this.notSamePassword = true
      } 
      if(!this.emptyPassword1 && !this.emptyPassword2 && !this.emptyPassword3 && !this.notSamePassword && !this.shortPassword && !this.shortPasswordCheck) {      
      let self = this
      const pwd = window.localStorage.getItem('pwd')
      if(pwd == this.password1) {      
      axios.put(`/user/update/session`, {
        old_password: this.Password1,
      password: this.password2,
      password_confirmation: this.password3
    })
    .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.showSuccessMessage = true
            }
        })
        .catch(e => {
          this.errors.push(e)
        })
      }
      }
      else {
        this.wrongPassword1 = true;
      }
    },    
    sendForm() {
      this.emptyName = false
      this.emptyLastName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.shortPassword = false
      this.shortPasswordCheck = false
      
      if (!this.form.first_name) {
        this.emptyName = true
      }
      if (!this.form.last_name) {
        this.emptyLastName = true
      }    
      if (!this.form.phone) {
        this.emptyPhone = true
      }
      if (!this.form.email) {
        this.emptyEmail = true
      }
      if(!this.emptyName && !this.emptyLastName && !this.emptyPhone && !this.emptyEmail) {
      let self = this
      this.sendEnabled = false
      axios.put(`/user/update/personal`, {
      email: this.form.email,
      first_name: this.form.first_name,
      last_name: this.form.last_name,
      university: this.form.university_id,
      faculty: this.form.faculty_id,
      phone: this.form.phone,
    })
      .then(response => {
        if (response.status === 200 || response.status === 201) {                  
              let user = {}

      user.first_name = this.form.first_name
      user.last_name = this.form.last_name
      user.email = this.form.email
      user.phone = this.form.phone
      user.university_name = this.form.university_name
      user.faculty_name = this.form.faculty_name
      self.showSuccessMessage = true
      this.$store.commit(SET_USER_INFO, user )
      this.sendEnabled = true
      window.localStorage.setItem('first_name1', self.form.first_name)
      window.localStorage.setItem('last_name1', self.form.last_name)
      window.localStorage.setItem('username1', self.form.username)
      window.localStorage.setItem('mail1', self.form.email)
      window.localStorage.setItem('phone1', self.form.phone)
      window.localStorage.setItem('university_name1', self.form.university_name)
      window.localStorage.setItem('faculty_name1', self.form.faculty_name)
            }
        })
        .catch(e => {
          this.errors.push(e)
        })
      }

    },
    getUniversities () {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectUniversity (opt) {
      this.form.university_id = opt.id
      this.facultyEnabled = true
      this.form.university_name = opt.name   
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFaculty (opt) {
      this.form.faculty_id = opt.id
      this.form.faculty_name = opt.name     
    },    
    logout () {
      this.isLogin1 = false
      const data = { updateLogin: true, isLogin: '' }
      this.$store.commit(SET_USER_INFO, data )
      this.$store.commit(UNSET_TOKEN)
      window.localStorage.setItem('isLogin', '')
      window.localStorage.setItem('access_token', null)
      const type_id = window.localStorage.getItem('type_id')
      if (type_id == 1) {
        this.$router.push('/admin-login')
      } else{
        this.$router.push('/user-login')
      }
      
    },
    saveProfile () {
      // console.log('kaydet')
    },
    showDate () {
      this.show = true
    }
  },
    computed: {
    ...mapGetters(['isLogin', 'first_name', 'last_name', 'mail1', 'phone','university_name','faculty_name', 'university_id','faculty_id'])
    },
/*     mounted() {
        this.form.first_name = this.first_name
  this.form.last_name = this.last_name
  this.form.email = this.mail1
  this.form.phone = this.phone
  this.form.university_name = this.university_name      
    }, */
  created () {
  this.form.first_name = this.first_name
  this.form.last_name = this.last_name
  this.form.email = this.mail1
  this.form.phone = this.phone
  this.form.university_name = this.university_name
  var self = this
    if(this.university_id !='') {
      axios.get(`/selected/faculties/${this.university_id}`)
        .then(response => {
          self.faculties = response.data
        })          
  }
  if(this.faculty_name !='') {
    this.facultyEnabled = true
      this.form.faculty_name = this.faculty_name        
  }
  
  this.form.university_id = this.university_id
  this.form.faculty_id = this.faculty_id    
    this.getUniversities()

  },
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/user";

.left-one{
  display: flex;
  align-items: center;
}
.user-settings__profil{
  display: flex;
  justify-content: space-between;
}

.exit-text{
  font-size:12px;
}
.user .sign-out[data-v-88e06970] {
}

.select__title {
  font-size: 13px !important;
  color: #31363a;
  opacity: 0.7;
}
  .mypointer {
    cursor: pointer;
  }
</style>
